import { useController } from "react-hook-form";
import _ from "lodash";

export const TextareaPp = props => {
    const { title, errors, defaultValue, isDisabled = false, ...others } = props;

    const {
      field
    } = useController({
      name: props.name,
      control: props.control,
      defaultValue: props.defaultValue
    });

    let err = _.get(errors, props.name);
  
    return (
        <>
            <div className="w-full">
                <div className={`pointer-events-none font-normal mb-2 ${props?.rules && err ? "text-red-600" : "text-gray-600"} text-left`}>
                    {title}
                    {props?.rules?.required?.value === true && <span className="text-red-500 p-2">*</span>}
                </div>
                <div
                    className={`${
                    props?.height ? props.height : ""
                    } px-3 py-1 relative w-full border border-gray-300 bg-white rounded ${
                    props?.rules && err ? "focus-within:border-red-600 border-red-600" : ""
                    }`}
                >
                <textarea 
                className={`block w-full appearance-none focus:outline-none bg-transparent focus:ring-0 text-base font-light text-black-300 ${
                    isDisabled && "bg-gray-50 cursor-not-allowed"
                 }`}
                placeholder={props.placeholder || ''}
                onChange={e => {
                    field.onChange(e.target.value);
                    if(props.onChange){
                        props.onChange(e, field.value);
                    }
                }}
                value={field.value}
                name={field.name}
                inputRef={field.ref}></textarea>
                </div>
                {props.rules && err && (
                    <p className=" text-xs text-red-600 h-3 text-left" id="email-error">
                        {props.rules && err && props.rules && err?.message}
                    </p>
                )}
            </div>
        </>
    );
  }